import React, { useEffect, useState } from "react";
import styles from './forgot-password.module.scss';
import logo from '../../../logo.png';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Typography, Grid, TextField, Box, IconButton, CircularProgress } from "@mui/material";
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';
import ForgotPasswordUiStore from "./forgot-password-ui-store";
//import ForgotPassowrdSchema from "../../shared/forms-schemas/forgot-password-schema";
import { useFormik } from 'formik';
import { useParams } from "react-router";
import PasswordField from "../../shared/components/password-field";
import ForgotPasswordSchema from "../../shared/forms-schemas/forgot-password-schema";
import RequestPasswordSchema from "../../shared/forms-schemas/request-password-schema";

const uiStore = new ForgotPasswordUiStore();

const ForgotPassword = ({ history, context, location }) => {
    const { submitData, error } = uiStore;
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showConfirmMessage, setShowConfirmMessage] = useState(false);
    const { code } = useParams();
    const [loading, setLoading] = useState(code ? true : false);

    const submitRequest = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: RequestPasswordSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const res = await submitData(values);
            if (res)
                setShowSuccessMessage(true);
            setLoading(false);
        },
    });

    const confirmRequest = useFormik({
        initialValues: {
            password: '',
            confirmPassword: ''
        },
        validationSchema: ForgotPasswordSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const response = await uiStore.confirmRequest(values, code);
            if (response)
                setShowConfirmMessage(true);
            setLoading(false);
        }
    });

    useEffect(() => {
        async function getReq() {
            await uiStore.getRequest(code);
            setLoading(false);
        }

        if (code) {
            getReq();
        }

    }, [code])


    return (
        <Grid container>
            <Grid sx={{ backgroundColor: '#FFF' }} item xl={6} lg={6} md={12} sm={12} xs={12}>
                <Box className={styles.formContainer} >
                    <Box className={styles.headerLogo}>
                        <a href="/">
                            <img className="logo" src={logo} alt='logo' />
                        </a>
                    </Box>

                    <Box className={styles.heading}>
                        <Typography variant="h4" color="#242333" sx={{ mb: 1, fontWeight: '600' }}>
                            {!code &&
                                <IconButton href="/login" sx={{ mr: 1 }}>
                                    <ArrowSquareLeft
                                        size="32"
                                        variant="Bulk"
                                    />
                                </IconButton>
                            }
                            {code ? 'Set New Password' : 'Forgot Password'}
                        </Typography>
                        <Typography variant="p" color="#888888" >
                            {code ? 'Enter new password to access account' : "No worries, we'll send you reset instructions"}
                        </Typography>
                    </Box>


                    {showConfirmMessage &&
                        <Alert severity="success">Password has been reset. You can login with the new password now</Alert>
                    }

                    {showSuccessMessage &&
                        <Alert severity="success">An Email has been sent password with reset instructions</Alert>
                    }

                    {error &&
                        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                    }

                    {!showConfirmMessage && !showSuccessMessage && !error &&
                        <>
                            {!code ?
                                <Box
                                    component="form"
                                    className={styles.formBox}
                                    onSubmit={submitRequest.handleSubmit}
                                >
                                    <TextField
                                        required
                                        id="email"
                                        label="Email Address"
                                        value={submitRequest.values.email}
                                        onChange={submitRequest.handleChange}
                                        onBlur={submitRequest.handleBlur}
                                        error={submitRequest.touched.email && Boolean(submitRequest.errors.email)}
                                        helperText={submitRequest.touched.email && submitRequest.errors.email}
                                    />

                                    <LoadingButton
                                        variant="contained"
                                        color="secondary"
                                        disabled={loading}
                                        endIcon={
                                            <ArrowSquareRight
                                                size="24"
                                                color="#FFFFFF"
                                                variant="Bulk"
                                            />
                                        }
                                        disableElevation
                                        className={styles.loginbtn}
                                        type='submit'
                                    >
                                        Send
                                    </LoadingButton>

                                </Box>
                                :
                                loading ?
                                    <CircularProgress />
                                    :
                                    <Box
                                        component="form"
                                        className={styles.formBox}
                                        onSubmit={confirmRequest.handleSubmit}
                                    >
                                        <Alert severity="info" sx={{textAlign: 'left'}}>It's recommnded not to use any of your old passwords.</Alert>
                                        <PasswordField
                                            required
                                            id="password"
                                            label="New Password"
                                            formik={confirmRequest}
                                            validate
                                        />

                                        <PasswordField
                                            required
                                            id="confirmPassword"
                                            label="Confirm New Password"
                                            formik={confirmRequest}
                                        />
                                        <LoadingButton
                                            variant="contained"
                                            color="secondary"
                                            disabled={loading || error}
                                            endIcon={
                                                <ArrowSquareRight
                                                    size="24"
                                                    color="#FFFFFF"
                                                    variant="Bulk"
                                                />
                                            }
                                            disableElevation
                                            className={styles.loginbtn}
                                            type='submit'
                                        >
                                            Update
                                        </LoadingButton>

                                    </Box>
                            }
                        </>
                    }
                </Box>
            </Grid>
            <Grid className={styles.gradiantBackground} item xl={6} lg={6} display={{ lg: "block", md: "none", sm: "none", xs: "none" }}>

                <Box className={styles.imgbackground}>
                    <Typography variant="h3" color="white" sx={{ mb: 1, fontWeight: '700', textAlign: 'center' }}>Stay in touch </Typography>
                    <Typography variant="h3" color="white" sx={{ mb: 1, fontWeight: '200', textAlign: 'center' }}>with your community</Typography>
                </Box>
            </Grid>
        </Grid >
    );

}

export default ForgotPassword;